import React from 'react';
import { DateTimePicker } from 'react-widgets';
import 'react-widgets/lib/scss/react-widgets.scss';

class DateSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            date: true,
            currentDate: '',
            time: false,
            defaultViews: ['month', 'year', 'decade', 'century']
        }
    }

    render() {
        let {disabled, date, time, defaultViews } = this.state;
        let {maxDate, todayDate, name, onValueChange, dayNotAllowed} = this.props;
        let views, dateFormat;
        if(dayNotAllowed){
            views = ['year', 'decade', 'century'];
            dateFormat = "YYYY/MM";
            todayDate = (todayDate) ? new Date(todayDate).toDateString('YYYY-MM') : '';
        }else{
            views = defaultViews;
            dateFormat = "YYYY/MM/DD";
        }
        return (
            <div>
                <DateTimePicker format={dateFormat} views={views} onViewChange={(event) => {}} date={date} time={time} max={maxDate} placeholder={todayDate} name={name} disabled={disabled} onChange={onValueChange}/>
            </div>
        )

    }
}
export default DateSelector;



// WEBPACK FOOTER //
// ./src/views/utils/dateSelector.js